/* eslint-disable no-undef */
import './Hompage.scss';
import './HomepageMobile.scss';

import React from 'react';
import { useTranslation } from 'react-i18next';

// import { buttonStyles, buttonStylesBlue, buttonStylesGreen } from '../../Components/docsAdministrative/JsObjectStyles';
// import Footer from '../../Components/shared/Footer/Footer';
import FooterConsulting from '../../Components/shared/Footer/FooterConsulting';
import NavbarConsulting from '../../Components/shared/Navbar/NavbarConsulting';
// import NavbarHome from '../../Components/shared/Navbar/NavbarHome';
import usePersistedLanguage from '../../hooks/usePersistedLanguage';
import useWindowSize from '../../hooks/useWindowSize';
// ! why React becomes Too slow ..? SVG takes too much
// Could not find a declaration file for module 'react-trello'. 'C:/Users/Reda El Ouahabi/Desktop/HTH/hth_frontend/node_modules/react-trello/dist/index.js' implicitly has an 'any' type.
//   Try `npm i --save-dev @types/react-trello` if it exists or add a new declaration (.d.ts) file containing `declare module 'react-trello';

function ContactUsConsulting() {

    // ! multiLanguages
    const { t, i18n } = useTranslation();

    // useEffect(() => {
    console.log(t, i18n);
    // const navigate = useNavigate();
    usePersistedLanguage();
    //   return () => {
    //     second
    //   }
    // }, [])

    //! const index = 11;

    // alert("START")

    // const data = {
    //     lanes: [
    //         {
    //             id: 'lane1',
    //             title: 'Planned Tasks',
    //             label: '2/2',
    //             cards: [
    //                 { id: 'Card1', title: 'Write Blog', description: 'Can AI make memes', label: '30 mins', draggable: false },
    //                 { id: 'Card2', title: 'Pay Rent', description: 'Transfer via NEFT', label: '5 mins', metadata: { sha: 'be312a1' } }
    //             ]
    //         },
    //         {
    //             id: 'lane2',
    //             title: 'Completed',
    //             label: '0/0',
    //             cards: []
    //         }
    //     ]
    // }
    const { device } = useWindowSize();

    console.log('deviiice', device);
    return (
        <React.Fragment>
            <div
                className='App-intro'
                style={{background:'linear-gradient(180deg, rgb(230, 240, 250) 0%, rgb(240, 245, 250) 50%, rgb(255, 255, 255) 100%)'}}
            >
                <NavbarConsulting />

                <div
                    className='rectangleP'
                    style={{marginTop:'60px',gap:device == 'desktop'?'135px':'24px'}}
                >
                    <div
                        className='frame108HomePage'
                        style={{alignItems:'center'}}
                    >
                        <div
                            className="homeExpertf28"
                            style={{width:'100%'}}
                        >
                            <h5
                                className='homeExpertf16 homeExpertf31B'
                                style={{color:'rgb(33, 77, 206)',fontSize:'72px',lineHeight:'70px'}}
                            >
                                {i18n.t('Grow with us.')}
                            </h5>
                        </div>
                        <div
                            className="horizontal-line"
                            style={{borderTop:'2px solid black',marginTop:device == 'desktop' ? '80px':'20px'}}
                        > </div>
                    </div>
                    <div style={{display:'flex',flexDirection:device == 'desktop' ? 'row':'column',gap:device == 'desktop'?'50px':'10px',paddingLeft:device == 'desktop' ? '100px':'10px',paddingRight:device == 'desktop' ? '100px':'10px',width:'90%'}}>
                        <div
                            className="homeExpertf28"
                            style={{width:device == 'desktop'?'60%':'100%'}}
                        >
                            <h5
                                className='homeExpertf16 homeExpertf31B'
                                style={{color:'black',fontSize:'72px',lineHeight:'70px'}}
                            >
                                {i18n.t('Together to the top!')}
                            </h5>
                            <h3
                                className='frame101HomePage'
                                style={{color:'black',fontSize:'24px',lineHeight:'56px',letterSpacing:'1.25px',alignSelf:'left'}}
                            >
                                {i18n.t('Let’s meet!')}
                            </h3>
                            <h1
                                className='frame101HomePage'
                                style={{color:'black',fontSize:'24px',lineHeight:'56px',letterSpacing:'1.25px',alignSelf:'self-start'}}
                            >
                                {i18n.t('We’ll make the coffee, who brings the cookies ?')}
                            </h1>
                        </div>
                        <div
                            className="homeExpertf28"
                            style={{width:device == 'desktop'?'40%':'100%',alignItems:'flex-start',gap:'20px'}}
                        >
                            <h1
                                className='frame101HomePage'
                                style={{color:'black',fontSize:'24px',lineHeight:'56px',letterSpacing:'1.25px',alignSelf:'start'}}
                            >
                                Email : contact@hightechhires.com
                            </h1>
                            <div
                                className="horizontal-line"
                                style={{borderTop:'2px solid rgb(220, 220, 220)',width:device == 'desktop'?'80%':'100%',marginTop:'0px'}}
                            ></div>
                            <h1
                                className='frame101HomePage'
                                style={{color:'black',fontSize:'24px',lineHeight:'56px',letterSpacing:'1.25px',alignSelf:'start'}}
                            >
                            Téléphone : +33 1 75 43 05 58
                            </h1>
                            <div
                                className="horizontal-line"
                                style={{borderTop:'2px solid rgb(220, 220, 220)',width:device == 'desktop'?'80%':'100%',marginTop:'0px'}}
                            ></div>
                            <h1
                                className='frame101HomePage'
                                style={{color:'black',fontSize:'24px',lineHeight:'56px',letterSpacing:'1.25px',alignSelf:'start'}}
                            >
                                Adresse : 74 PLACE DU DR FELIX LOBLIGEOIS
                                75017 Paris – FRANCE
                            </h1>
                            <div
                                className="horizontal-line"
                                style={{borderTop:'2px solid rgb(220, 220, 220)',width:device == 'desktop'?'80%':'100%',marginTop:'0px'}}
                            ></div>
                            <h1
                                className='frame101HomePage'
                                style={{color:'black',fontSize:'24px',lineHeight:'56px',letterSpacing:'1.25px',alignSelf:'start'}}
                            >
                                Follow us on LinkedIn
                            </h1>
                        </div>
                    </div>
                </div>
                <FooterConsulting
                    styleProps={{background: '#005E23',
                    }}
                />
            </div>

            {/*<Footer
                styleProps={{
                    position: 'absolute',
                    left: '0px',
                    top: '5229.66px',
                    width: '100%'
                }} />*/}

        </React.Fragment>
    );
}

export default ContactUsConsulting;